$(function()
{
    let isDesktop = window.matchMedia("(min-width: 768px)").matches;

    $(document).on("click", function(evt)
    {
        const basketOpenClass = (App.config.basket.previewType === "right") ? "open-right" : "open-hover";

        if ($("#vue-app").hasClass(basketOpenClass))
        {
            if ((evt.target != $(".basket-preview")) &&
                (evt.target != document.querySelector(".basket-preview-hover")) &&
                (evt.target.classList[0] != "message") &&
                ($(evt.target).parents(".basket-preview").length <= 0 && $(evt.target).parents(".basket-preview-hover").length <= 0))
            {
                evt.preventDefault();
                $("#vue-app").toggleClass(basketOpenClass || "open-hover");
            }
        }
    });

    const $toggleListView = $(".toggle-list-view");
    $toggleListView.on("click", function(evt)
    {
        evt.preventDefault();

        // toggle it's own state
        $toggleListView.toggleClass("grid");

        // toggle internal style of thumbs
        $(".product-list, .cmp-product-thumb").toggleClass("grid");
    });

    $(document).on("click", ".contact-wrapper__toggle", function()
    {
        $(".contact-wrapper").toggleClass("is-open");
        $(".etrusted-badge-container").toggleClass("less-index");
    });

    //<editor-fold desc="Wenn Touch Device Megamenü öffnen">
    // $(".mainmenu__first-level-link").click(function(ev)
    // {
    //     if ($("body").hasClass("touch"))
    //     {
    //         ev.preventDefault();
    //         $(this).trigger("mouseover");
    //     }
    // });
    // $(".mainmenu__link.mainmenu__link--has-child").mouseover(function()
    // {
    //     $(".mainmenu__first-level .mainmenu__first-level-item:first-child").addClass("active-level");
    // });
    // $(".mainmenu__first-level-item").mouseover(function()
    // {
    //     $(".mainmenu__first-level-item").removeClass("active-level");
    //     $(this).addClass("active-level");
    // });
    // $(".mainmenu__second-level-item").mouseover(function()
    // {
    //     $(".mainmenu__second-level-item").removeClass("active-level");
    //     $(this).addClass("active-level");
    // });
    //</editor-fold>

    //<editor-fold desc="Mobile Navigation Handling des Overlays / Close">
    $(".mobile-navigation__close").click(function()
    {
        $(".mobile-navigation__breadcrumb .btn-close").click();
    });
    if (!isDesktop)
    {
        var tsInterval222 = setInterval(function()
        {
            if ($(".mobile-navigation__overlay").length)
            {
                //$('.mobile-navigation__overlay').appendTo('html');
                $(".mobile-navigation__overlay").insertBefore("head");
                clearInterval(tsInterval222);
            }
        }, 250);
    }
    //</editor-fold>

    //<editor-fold desc="Muster bestellen Modal - beim Öffnen Formular Felder mit Werten füllen">
    $(".js--single__muster-link").click(function()
    {
        $("input[name=\"article\"]").val($(this).attr("article"));
        $("input[name=\"articlename\"]").val($(this).attr("articlename"));
    });
    //</editor-fold>

    //<editor-fold desc="Autocomplete Feld Fokus triggern">
    $(".search-autocomplete").click(function()
    {
        $(".search-box__input").focus();
    });
    //</editor-fold>

    //<editor-fold desc="Zu den Bewertungen scrollen">
    $(".js--single__feedback-link").click(function(ev)
    {
        ev.preventDefault();

        document.dispatchEvent(new CustomEvent('toggle-details-lazy-load'));

        $([document.documentElement, document.body]).animate({
            scrollTop: $(".feedback-container").offset().top - 250
        }, 2000);

        setTimeout(() => {
            document.dispatchEvent(new CustomEvent('toggle-details-lazy-load'));
        }, 2000);
    });
    //</editor-fold>

    //<editor-fold desc="Swiper Button Klick Scroll to Element">
    $(".content-swiper__button").click(function(ev)
    {
        ev.preventDefault();
        let target = $(this).attr("href");

        $([document.documentElement, document.body]).animate({
            scrollTop: $(target).offset().top - 100
        }, 2000);
    });
    //</editor-fold>

    //<editor-fold desc="Sticky Tabs Artikelseite trigger Klick to normal Tabs">
    $("body").on("click", ".cloned-tabs .single__nav-link", function()
    {
        var href = $(this).attr("href");
        $(".single__nav-tabs:not(.cloned-tabs) .single__nav-link[href=\"" + href + "\"]").click();
    });
    //</editor-fold>

    // <editor-fold desc="Bei Cateory-Item Thumb Click das Hauptbild anpassen">
    $(".category-item__thumbs-img").click(function(ev)
    {
        ev.stopPropagation();
        ev.preventDefault();
        var href = $(this)[0].dataset.middleurl;
        $(this).closest(".category-item__image").find(".category-item__image-img-1").attr("src", href);
        $(this).closest(".category-item__image").find(".category-item__thumbs-swiper .active").removeClass("active");
        $(this).closest(".swiper-slide").addClass("active");
    });
    //</editor-fold>

    //<editor-fold desc="Artikelseite scroll to Tab">
    $(".single__nav-tabs a").click(function(ev)
    {
        ev.preventDefault();
        // .active an a-tag
        $(".single__nav-tabs a").removeClass("active");
        $(this).addClass("active");
        var href = $(this).attr("href");

        $([document.documentElement, document.body]).animate({
            scrollTop: $(href).offset().top - 180
        }, 1000);
    });
    //</editor-fold>

    //<editor-fold desc="Trigger Filter Klick">
    var filterClicked = false;
    $(document).on("click", ".category__right-side .category__filter-btn-close-or-accept", function()
    {
        if (!filterClicked)
        {
            $(".category__filter-btn-close-or-accept")[0].dispatchEvent(new CustomEvent("click"));
            filterClicked = true;
        }
    });
    //</editor-fold>

    //<editor-fold desc="Lightbox Anpassung für iframes">
    $("[data-lightbox]").click(function()
    {
        $("#lightbox .lb-container").find("iframe").remove();

        if ($(this)[0].dataset.lightbox == "iframe")
        {
            $(".lb-outerContainer").addClass("contains-iframe");
            let href = $(this).attr("href");
            var _this = $(this);
            $(this).attr("href", "https://via.placeholder.com/500x500");
            if ($(window).width() > 586 && $(window).width() < 992)
            {
                $("#lightbox .lb-container").prepend("<iframe src=\"" + href + "\" width=\"500\" height=\"500\"></iframe>");
            }
            else if ($(window).width() > 991)
            {
                $("#lightbox .lb-container").prepend("<iframe src=\"" + href + "\" width=\"696\" height=\"578\"></iframe>");
            }
            else
            {
                $("#lightbox .lb-container").prepend("<iframe src=\"" + href + "\" width=\"300\" height=\"300\"></iframe>");
            }
            $("#lightbox .lb-image").addClass("d-none");
            setTimeout(function()
            {
                _this.attr("href", href);
            }, 2000);

        }
        else
        {
            $("#lightbox .lb-image").removeClass("d-none");
            $(".lb-outerContainer").removeClass("contains-iframe");
        }
    });
    var kachelIsClicked = false;
    $(".homepage__category-widget-col").click(function(ev)
    {
        if (!kachelIsClicked && typeof $(this).attr("data-lightbox") != "undefined")
        {
            kachelIsClicked = true;
            window.location.href = $(this).find(".homepage__category--button").attr("href");
        }
    });
    if ($(".page-category-content").length > 0)
    {
        const scriptLB = document.createElement("script");

        scriptLB.type = "text/javascript";
        scriptLB.id = "lightboxscript";
        scriptLB.src = App.pluginPath.replace("weberbuero", "ceres") + `/js/dist/lightbox.min.js`;

        document.body.appendChild(scriptLB);
    }
    //</editor-fold>

    // TODO: keine ahnung was das hier soll
    $(".pagination__page-item").click(function()
    {
        if ($(this).hasClass("pagination__page-item"))
        {
            if ($(this).find("a").attr("href") != "" && typeof $(this).find("a").attr("href") !== "undefined")
            {
                window.location.href = $(this).find("a").attr("href");
            }
        }
    });

    $(document).on("click", ".basket-preview-overlay", function()
    {
        document.body.classList.toggle("basket-open");
    });

    //<editor-fold desc="SEO Select im Widget soll zur jeweiligen URL verlinken, Attribut pflegt Matthias im Shopbuilder">
    $(".homepage__seo--select").change(function()
    {
        window.location.href = $(this).val();
    });
    //</editor-fold>

    $("body").on("mouseover", ".category-item__image", function()
    {
        if ($(this).find(".load-on-hover").length)
        {

            $(this).find(".load-on-hover").each(function(index, item)
            {
                $(item).attr("src", $(item)[0].dataset.src).removeClass("load-on-hover");
            });
        }
    });

    // load iframe 3d later on click, doesnt work in vue for some weird reason
    $("body").on("click", ".single__3d-thumb", function()
    {
        let src = $(this)[0].dataset.url;
        $(".responsive-iframe--3d iframe").attr("src", src);
    });

    //<editor-fold desc="Unterkategorien in der Kategorie vom Abstand anpassen">
    if ($(".category__teaser-sub-cats").length)
    {
        // height von sub cats - überlappen zu darüber + 20px -> margin-top des texts drunter
        var subcatHeight = $(".category__teaser-sub-cats").outerHeight();
        var subcatTop = parseInt($(".category__teaser-sub-cats").css("top"));

        $(".category__teaser-sub").css("paddingTop", subcatHeight + subcatTop + 20 + "px");
    }
    //</editor-fold>

    //<editor-fold desc="tablet megamenu stuff">
    if ($("body").hasClass("touch"))
    {
        // INFO: tablet megamenu stuff
        $(".mainmenu__item a.mainmenu__link:not(.is-clicked)").click(function(ev)
        {
            ev.preventDefault();
            $(this).addClass("is-clicked");
            $(".mainmenu__item a.mainmenu__link.is-clicked").unbind("click");
        });
    }
    //</editor-fold>

    //<editor-fold desc="Artikel Feature Liste, an die Listen-Items SVGs davor setzen">
    if ($(".single__features").length)
    {
        $(".single__features li").prepend("<svg width=\"8\" height=\"12\"><use xlink:href=\"#svg_arrow\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"></use></svg>");
    }
    //</editor-fold>

    //<editor-fold desc="Special Classes für CSS Handling">
    window.dispatchEvent(new Event("resize"));
    if (!!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform))
    {
        $("body").addClass("is-ios");

        document.addEventListener("gesturestart", function(e)
        {
            e.preventDefault();
        });
    }
    if (!!navigator.platform && /Mac/.test(navigator.platform))
    {
        $("body").addClass("is-mac");
    }
    if (navigator.userAgent.indexOf("Safari") != -1 &&
        navigator.userAgent.indexOf("Chrome") == -1)
    {
        $("body").addClass("is-safari");
    }
    //</editor-fold>

    //<editor-fold desc="Amazon Seite anpassen">
    if (window.location.pathname == "/amazon-connect-accounts")
    {
        $("body").addClass("is-amazon-error-page");
    }
    //</editor-fold>

    var itemscopeBottom = 0;
    var uspContainerTop = 0;
    if (App.templateEvent == "tpl.item")
    {
        function myTimer()
        {
            if ($("div[itemscope=\"itemscope\"]").length)
            {
                myStopFunction();

                itemscopeBottom = $("div[itemscope=\"itemscope\"]")[0].getBoundingClientRect().bottom;
                uspContainerTop = $(".single__wrapper .homepage__image-text-widget--container")[0].getBoundingClientRect().top;
            }
        }

        let myVar = setInterval(myTimer, 1000);

        function myStopFunction()
        {
            clearInterval(myVar);
        }
    }
});

jQuery(window).on("load", function()
{
    $("html").addClass("has-loaded");

    if (App.templateEvent === "tpl.item")
    {
        setTimeout(function()
        {
            window.scrollTo(0, 0);
        }, 250);
    }
});
